export default (valor) => {
    return parseFloat(valor).toFixed(2).toString().replace('.', ',')
}